import { Signal } from "@lit-labs/signals";
import type { WorldsQueryResult } from "api-contracts/rpc/worlds-query";
import type { IBackofficeWorldsState } from "./types";

export class BackofficeWorldsState implements IBackofficeWorldsState {
  readonly worlds = new Signal.State<WorldsQueryResult | null>(null);
  readonly loading = new Signal.State<boolean>(false);
}
